export enum OBM_API_PLATFORMS {
    GOOGLE_ADS = 'google_ads',
    FACEBOOK_ADS = 'facebook_ads'
}

export const budgetManagerPlatformMapping = {
    [OBM_API_PLATFORMS.GOOGLE_ADS]: 'Google Ads',
    [OBM_API_PLATFORMS.FACEBOOK_ADS]: 'Facebook Ads',
};

export const OBM_API_ERRORS = {
    CLUSTER_UNAUTHORIZED: 'clusterUnauthorized',
};
